import ninegrid from "../index.js";
import {nxDiv} from "./_nxDiv.js";

class nxPanel extends nxDiv {

	constructor() {
		super();
	}

	connectedCallback() {
		if (super.connectedCallback()) this.#init();
	}

	#init = () => {
		const caption = this.getAttribute("caption");
		const columns = this.getAttribute("columns") || "";
		const rowsHeight = this.getAttribute("rows-height")?.replace(/,/g, " ") || "";

		const htmlTmpl = document.createElement("template");
		htmlTmpl.innerHTML = `
			<style>
				@import "https://cdn.jsdelivr.net/npm/ninegrid2@${ninegrid.version}/dist/css/nxPanel.css";
				${ninegrid.getCustomPath(this,"nxPanel.css")}
			</style>
            
			<div class="head ${caption ? '' : 'hide'}">
				<div class="caption"><span>${caption}</span></div>
			</div>
			<div class="body">
				<nx-layout2 columns="${columns}" rows-height="${rowsHeight}">
					${this.originContents}
				</nx-layout2>
			</div>
        `;

		(this.shadowRoot || this).appendChild(htmlTmpl.content.cloneNode(true));
	}
}

if (!customElements.get('nx-panel')) {
	customElements.define("nx-panel", nxPanel);
}
